import { ComponentType, ComponentProps } from 'react';
import { useSetRecoilState } from 'recoil';
import { useLocation, useNavigate } from 'react-router-dom';
import { ModalActionProps, ModalProps } from 'models/AutoModals';
import modal from 'recoil/atoms/modal';
import { FakePromise, replaceItemAtIndex } from 'utils/common';


const useModal = () => {
    const setModals = useSetRecoilState(modal);
    const navigate = useNavigate();
    const location = useLocation();

    const showModal = <T extends ComponentType<ModalActionProps & any>>(
        component: T,
        props: Omit<ComponentProps<T>, keyof ModalActionProps>,
        modalProps: ModalProps,
        replace: boolean = false
    ): FakePromise<Parameters<ComponentProps<T>['onFinish']>[0]> => {
        modalProps.id = modalProps.id || Math.random().toString();

        navigate(location, {state: {modal: modalProps.id}});

        return new FakePromise((resolve, reject) => {
            const newModal = {
                component,
                props,
                modalProps,
                promise: {resolve, reject},
            };
            setModals(old => replace ?
                replaceItemAtIndex(old, old.length - 1, newModal) :
                [...old, newModal]
            );
        })
    };

    const hideModal = (delta: any = -1) => navigate(typeof delta === 'number' ? delta : -1);

    const hideAll = () => navigate(location, {state: {}});

    const _hideLastModal = () => setTimeout(
        () => setModals(old => old.slice(0, old.length - 1)),
        250
    );

    const _clearModals = () => setModals([]);

    return {
        showModal,
        hideModal,
        hideAll,
        _hideLastModal,
        _clearModals,
    };
}

export default useModal;
